import { BrandNameValidator } from './brandNameValidator';
import { EpaRegistrationNumberValidator } from './epaRegistrationNumberValidator';
import { PesticidesPackagingValidator } from './pesticidesPackagingValidator';

export const registeredPesticidesFieldValidators = [
  new BrandNameValidator(),
  new EpaRegistrationNumberValidator(),
  new PesticidesPackagingValidator(),
];
